<template>
  <div style="width: 90vw">
    <el-container class="contain-6" style="padding: 25px 25px">


      <div class="bbb">

        <el-drawer
            title="报警设置"

            :visible.sync="dialog"
            direction="ltr"
            custom-class="demo-drawer"
            ref="drawer"
        >
          <div class="demo-drawer__content">
            <el-form :model="form" style="margin-left: 50px;">
              <el-form-item label="游戏名称:" :label-width="formLabelWidth">
                <el-select v-model="form.name" placeholder="游戏选择"
                           style="width: 280px"
                           filterable clearable>
                  <el-option
                      v-for="item in optionsGame"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="负责人:" :label-width="formLabelWidth">
                <el-input v-model="form.sendPersion" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="当日消耗:" :label-width="formLabelWidth">
                <el-input v-model="form.val1" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="当日ROI:" :label-width="formLabelWidth">
                <el-input v-model="form.val2" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="3日ROI:" :label-width="formLabelWidth">
                <el-input v-model="form.val3" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="7日ROI:" :label-width="formLabelWidth">
                <el-input v-model="form.val4" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="3日倍率:" :label-width="formLabelWidth">
                <el-input v-model="form.val5" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="7日倍率:" :label-width="formLabelWidth">
                <el-input v-model="form.val6" autocomplete="off" class="inputA" style="width: 280px"></el-input>
              </el-form-item>
            </el-form>
            <div class="demo-drawer__footer">
              <el-button style="margin-left: 100px" @click="cancelForm">取 消</el-button>
              <el-button type="primary" @click="add" :loading="loading">
                {{ loading ? '提交中 ...' : '确 定' }}
              </el-button>
            </div>
          </div>
        </el-drawer>
        <el-header style="display: flex;height: 40px;">

          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <span class="style-title">负责人:</span>
          <el-input v-model="person" placeholder="请输入负责人" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>

          <!--          <el-select v-model="valueGame" placeholder="负责人" size="mini"-->
          <!--                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"-->
          <!--                     filterable clearable>-->
          <!--            <el-option-->
          <!--                v-for="item in optionsGame"-->
          <!--                :key="item"-->
          <!--                :label="item"-->
          <!--                :value="item">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search" icon="el-icon-refresh">
            刷新
          </el-button>

          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="dialog = true" icon="el-icon-folder-add">
            增加
          </el-button>


        </el-header>
        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            max-height="80vh"
            height="79vh"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgb(244,244,245)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row

        >
          <el-table-column
              prop="gameName"
              label="游戏名"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="val1"
              label="当日消耗"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="val2"
              label="当日ROI"
              min-width="160"
          >

          </el-table-column>

          <el-table-column
              prop="val3"
              label="3日ROI"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="val4"
              label="7日ROI"
              min-width="160"
          >

          </el-table-column>

          <el-table-column
              prop="val5"
              label="3日倍率"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="val6"
              label="7日倍率"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="sendPersion"
              label="@负责人"
              min-width="160"
          >

            <template slot-scope="scope">

              <span style="color: #3a8ee6"> @{{ scope.row.sendPersion }}
</span>

            </template>

          </el-table-column>
          <el-table-column
              prop="bfUv"
              label="操作"
              min-width="160"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button>
              <el-button type="text" style="color: #d65055" @click="del(scope.row)" size="small">删除</el-button>

            </template>
          </el-table-column>
        </el-table>


      </div>


    </el-container>

  </div>
</template>
<script>
export default {
  name: "ProjectBroad",

  data() {

    return {
      tableData: [],
      currentPage: 1,
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      valueGame: "",
      dialog: false,

      form: {
        name: '全民剧本大师',
        sendPersion: '小薇',
        val1: 1,
        val2: 1,
        val3: 1,
        val4: 1,
        val5: 1,
        val6: 1,

      },
      person: '',
      formLabelWidth: '80px',
      timer: null,
      optionsGame: []

    }


  }, watch: {}, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  }, methods: {
    del(row) {

      this.$axios
          .get('/warning/delete?gameName=' + row.gameName, {})
          .then(successResponse => {
            this.search()
          })

    },

    cancelForm() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },
    createExportData() {

      console.log("下载", this.value1)

      for (let j = 0; j < this.titleHeads.length; j++) {


        this.json_fields[this.titleHeads[j].sta_view_value] = this.titleHeads[j].sta_value
      }


      this.json_data = this.tableData


      return this.json_data

    },


    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value.toFixed(2)

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, edit(row) {

      console.log(row)
      this.dialog = true
      this.form = row

      this.form.name = row.gameName
    },
    add() {

      var a = [{name: '当日消耗', val: 'val1'},
        {name: '当日ROI', val: 'val2'},
        {name: '3日ROI', val: 'val3'},
        {name: '7日ROI', val: 'val4'},
        {name: '3日倍率', val: 'val5'},
        {name: '7日倍率', val: 'val6'}]

      var that = this

      a.forEach(function (e) {

        that.$axios
            .post('/warning/add', {
              gameName: that.form.name,
              sendPersion: that.form.sendPersion,
              warnValue: that.form[e.val],
              warnType: e.name,
              warnPaltform:'抖音'
            })
            .then(successResponse => {

              that.search()

            }).catch((err) => {
          //请求失败的回调函数
          console.log(err)
          console.log('失败')
        })

      })


    },
    search() {

      this.loading = true

      this.$axios
          .post('/warning/find', {
            gameName: this.valueGame,
            person: this.person,
            pf:"抖音"

          })
          .then(successResponse => {


            var a = successResponse.data.data

            var b = []

            a.forEach(function (e) {

              var f = true

              for (var i = 0; i < b.length; i++) {

                //存在该游戏
                if (b[i].gameName === e.gameName) {

                  switch (e.warnType) {

                    case '当日消耗':
                      b[i]['val1'] = e.warnValue
                      break
                    case '当日ROI':
                      b[i]['val2'] = e.warnValue
                      break
                    case '3日ROI':
                      b[i]['val3'] = e.warnValue
                      break
                    case '7日ROI':
                      b[i]['val4'] = e.warnValue
                      break
                    case '3日倍率':
                      b[i]['val5'] = e.warnValue
                      break
                    case '7日倍率':
                      b[i]['val6'] = e.warnValue
                      break

                  }

                  f = false

                }

              }
              if (f) {

                switch (e.warnType) {

                  case '当日消耗':
                    e['val1'] = e.warnValue
                    break
                  case '当日ROI':
                    e['val2'] = e.warnValue
                    break
                  case '3日ROI':
                    e['val3'] = e.warnValue
                    break
                  case '7日ROI':
                    e['val4'] = e.warnValue
                    break
                  case '3日倍率':
                    e['val5'] = e.warnValue
                    break
                  case '7日倍率':
                    e['val6'] = e.warnValue
                    break

                }

                b.push(e)
              }
            })
            console.log(b)
            this.tableData = b


            this.loading = false
          }).catch((err) => {
        //请求失败的回调函数
        console.log(err)
        console.log('失败')
      })


    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {
    this.height = window.innerHeight;
    // this.date_format_new()
    this.findGame()
    this.search()

  }


}
</script>
<style>
.inputA {

  width: 220px;

}

.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}

.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}



.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 5px;
  height: 12px;
  background-color: transparent;
}

/* 修改el-table__body-wrapper样式的层级--fixed滚动条无法滚动 */
.el-table__fixed,
.el-table__fixed-right {
  pointer-events: none;
  /* 解决因为滚动条无法滚动导致无法勾选和全选的问题 */

  td {
    pointer-events: auto;
  }

  th {
    pointer-events: auto;
  }
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;
  //margin-left: 2%;

  min-height: 80vh;
}

</style>

<style scoped>

.new_s {

  font-family: Arial;
  /*color: #2E95FB;*/
  /*font-weight: 500*/

}


.old_s {
  font-family: Arial;
  /*color: #ff0000;*/
  /*font-weight: 400*/

}

.el-row {
  margin-bottom: 10px;
  justify-items: center;
  align-items: center;
  align-content: center;
  text-align: center;
  vertical-align: middle;
  vertical-align: center;


}

.el-col {

  justify-items: center;
  align-items: center;
  align-content: center;
  text-align: center;
  vertical-align: middle;
  vertical-align: center;
  border-radius: 4px;
}

.bg-purple-dark {
  /*background: #99a9bf;*/
  border: 1px solid blue;
}

.bg-purple {
  background: #d3dce6;
  padding-top: 10px;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {


  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 0px 0;
  background-color: #f9fafc;
}
</style>

<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>